import React from "react";
import { useAppSelector } from "@store/index";
import { chartDrawerSelector } from "@store/slices/chart-drawer-slice";
import BarChartConfigDrawer from "./bar-chart-config";
import GroupedBarChartConfigDrawer from "./grouped-bar-config";
import DonutChartConfigDrawer from "./DonutChartConfigDrawer";
import TableChartConfigDrawer from "./TableChartConfigDrawer";
import CrosstabConfigDrawer from "./CrosstabConfigDrawer";
import LineChartConfigDrawer from "./LineChartConfigDrawer";

const ChartConfigDrawer: React.FC = () => {
  const { isDrawerOpen, currentChartType } =
    useAppSelector(chartDrawerSelector);

  // Don't render anything if drawer is closed or no chart type is selected
  if (!isDrawerOpen || !currentChartType) {
    return null;
  }

  // Route to the appropriate chart-specific drawer based on chart type
  switch (currentChartType) {
    case "bar":
      return <BarChartConfigDrawer />;
    case "grouped_bar":
      return <GroupedBarChartConfigDrawer />;
    case "donut":
      return <DonutChartConfigDrawer />;
    case "table":
      return <TableChartConfigDrawer />;
    case "crosstab":
      return <CrosstabConfigDrawer />;
    case "pie":
      // TODO: Implement PieChartConfigDrawer when needed
      return <div>Pie chart configuration coming soon...</div>;
    case "line":
      return <LineChartConfigDrawer />;
    default:
      console.warn(`Unknown chart type: ${currentChartType}`);
      return null;
  }
};

export default ChartConfigDrawer;
